export enum EMitekCheckStatus {
  Unknown = 0,
  PROCESSING,
  COMPLETED,
  ERROR
}